export default "__VITE_ASSET__B9Y$57zK__"